import { Arrow } from '@sprd/sprd-component-kit/v2';
import clsx from 'clsx';
import { AmplienceLinkType } from '@/types/amplience';
import AmplienceLink from '../Common/AmplienceLink';

type SliderHeader = {
  heading?: string;
  showAllLink?: AmplienceLinkType | AmplienceLinkType[];
  className?: string;
};

export const SliderHeader = ({ heading, showAllLink, className = '' }: SliderHeader) => {
  return (
    <div className="mb-4 flex items-center justify-between gap-2 px-6 md:mb-6 md:px-8 lg:px-16 xl:px-[90px]">
      <div className="min-w-[100px]">
        {heading && (
          <h2
            className={clsx(
              'text-xl font-bold uppercase sm:text-2xl md:text-[1.75rem] lg:text-[2rem]',
              className
            )}
          >
            {heading}
          </h2>
        )}
      </div>
      {showAllLink &&
        Array.isArray(showAllLink) &&
        showAllLink.map((link, index) => (
          <span key={index}>
            <AmplienceLink
              link={link}
              className="flex min-w-20 cursor-pointer items-center justify-end self-end text-sm font-semibold text-black sm:justify-center"
            >
              <span className={clsx('flex items-center text-center', className)}>
                <span>{link.label}</span>
                <Arrow className={clsx(className, 'size-4')} />
              </span>
            </AmplienceLink>
          </span>
        ))}
    </div>
  );
};
